<template>
  <div>
    <el-card class="mb16">
      <table-list :show-page="false" :data="[recipe]">
        <el-table-column align="center" :label="$t('编号')" prop="num" />
        <el-table-column align="center" :label="$t('图片')">
          <template v-slot="{row}">
            <preview-img :img-url="row.cover" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('名称')" prop="name" />
        <el-table-column align="center" :label="$t('发布者编号')" prop="userNum" />
        <el-table-column align="center" :label="$t('发布者昵称')" prop="username" />
        <el-table-column align="center" :label="$t('菜谱收入')" prop="allPrice" sortable />
      </table-list>
    </el-card>

    <el-card>
      <template #header>
        <h4>{{$t('收入详情')}}</h4>
      </template>

      <el-form size="small" inline>
        <el-form-item :label="$t('订单号')">
          <el-input v-model="searchForm.num" clearable :placeholder="$t('订单号')" />
        </el-form-item>
        <el-form-item :label="$t('交易方式')">
          <dict-select clearable v-model="searchForm.payType" flag="PAY_TYPE" />
        </el-form-item>
        <el-form-item :label="$t('交易状态')">
          <dict-select clearable v-model="searchForm.status" flag="ORDER_STATUS" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
          <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
        </el-form-item>
      </el-form>

      <table-list
          ref="list"
          :data="tableData"
          :request-params="{cookbookNum: $route.query.num}"
          :search-params="searchForm"
          @selection-change="selection = $event"
          @query="handleSearch">
        <el-table-column align="center" :label="$t('订单号')" prop="num" />
        <el-table-column align="center" :label="$t('用户编号')" prop="userNum" />
        <el-table-column :label="$t('内容')" align="center">
          <template v-slot="{row}">
            <dict-text :status="row.orderType" dict-flag="ORDER_TYPE" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('菜谱编号')" prop="cookbookNum" />
        <el-table-column align="center" :label="$t('金额')" prop="price" />
        <el-table-column :label="$t('交易方式')" prop="payType" align="center">
          <template v-slot="{row}">
            <dict-text :status="row.payType" dict-flag="PAY_TYPE" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('交易状态')" prop="status" align="center">
          <template v-slot="{row}">
            <dict-text :status="row.status" dict-flag="ORDER_STATUS" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('交易时间')" align="center">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
      </table-list>
    </el-card>

  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import DictSelect from "@/components/dict/DictSelect.vue";
import DictText from "@/components/dict/DictText.vue";

export default {
  name: "IncomeList",
  components: {DictText, DictSelect, PreviewImg, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      recipe: {}
    }
  },
  created() {
    this.loadRecipeDetail();
  },
  methods: {
    // 菜谱详情
    async loadRecipeDetail() {
      try {
        let res = await request(this.$api.cookbook.detail, this.$route.query);
        this.recipe = res.cookbook;
      } catch (e) {
        console.log(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.anOrder.listCbIn, params);
        this.tableData = res.anOrders;
        this.recipe.allPrice = res.allIn[0] || 0;
        setTotal(res?.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

.btn-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}


</style>
